export default {
  nl: {
    days: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
    daysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    daysMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    months: [
      'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus',
      'september', 'oktober', 'november', 'december',
    ],
    monthsShort: [
      'jan', 'feb', 'mar', 'apr', 'mei', 'jun',
      'jul', 'aug', 'sep', 'okt', 'nov', 'dec',
    ],
    today: 'Vandaag',
    clear: 'Clear',
    format: 'dd.mm.yyyy',
    titleFormat: 'MM yyyy',
    weekStart: 0,
  },
};
